import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  centered?: boolean;
  light?: boolean;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  centered = true,
  light = false,
  className = ''
}: SectionHeadingProps) {
  return <div className={`max-w-3xl ${centered ? 'mx-auto text-center' : ''} ${className}`} data-id="element-266">
      {eyebrow && <motion.span initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className={`block text-sm font-semibold uppercase tracking-wider mb-3 ${light ? 'text-navy-300' : 'text-navy-600'}`} data-id="element-267">
          {eyebrow}
        </motion.span>}
      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className={`text-3xl md:text-4xl font-bold mb-4 tracking-tight ${light ? 'text-white' : 'text-slate-900'}`} data-id="element-268">
        {title}
      </motion.h2>
      {description && <motion.p initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className={`text-lg md:text-xl ${light ? 'text-navy-100' : 'text-slate-600'}`} data-id="element-269">
          {'As companies grow, complexity increases faster than HR capacity.'}
        </motion.p>}
    </div>;
}